import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { ChangeNavbar } from '../actions';

import {
  Container,
  Row,
  Col
} from 'reactstrap';

class TermsAndPolicy extends Component {
  constructor(props) {
    super(props);
    this.props.SetHeaderNavbar(false);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <section className="content no-header">
        <Container>
          <Row>
            <Col>
              <h1><Translate id="terms_and_policy.title">Legal, Privacidad y Terminos de Uso</Translate></h1>

              <h2><Translate id="terms_and_policy.legal.title">Legal</Translate></h2>
              <p>
                <Translate id="terms_and_policy.legal.text_1">
                  En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan los siguientes datos:
                </Translate>
              </p>
              <p>
                <Translate id="terms_and_policy.legal.text_2">
                  La empresa titular del dominio web es Gone Mad Studios Coop. V. (en adelante Gone Mad Studios), con domicilio social en C/ Maestro Manfredo Monforte, 18 (Catarroja). CIF: F-40556862. Correo electrónico de contacto: gonemadstudios@gmail.com.
                </Translate>
              </p>
              <h2><Translate id="terms_and_policy.privacy.title">Privacidad</Translate></h2>
              <h3><Translate id="terms_and_policy.privacy.subtitle_1">Cómo recopilamos, tratamos y protegemos tu información</Translate></h3>

              <p>
                <Translate id="terms_and_policy.privacy.text_1">
                  Esta Política de Privacidad rige la manera en que Gone Mad Studios recopila, utiliza, mantiene y divulga la información recogida de los usuarios del sitio web www.gonemadstudios.com. Esta política de privacidad se aplica al sitio y todos los productos y servicios ofrecidos.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.privacy.subtitle_2">Información de identificación personal</Translate></h3>

              <p>
                <Translate id="terms_and_policy.privacy.text_2">
                  En la actualidad este sitio no recopila información personal de los usuarios.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.privacy.subtitle_3">Información de identificación no personal</Translate></h3>

                <p>
                  <Translate id="terms_and_policy.privacy.text_3">
                    Podemos recopilar información de identificación no personal, totalmente anónima, sobre los usuarios cuando interaccionan con nuestro sitio. La información de identificación no personal puede incluir el nombre del navegador, el tipo de equipo e información técnica sobre los usuarios mediante la conexión a nuestro sitio, tales como el sistema operativo y los proveedores de servicios de Internet utilizados y otra información similar.
                  </Translate>
                </p>

              <h2><Translate id="terms_and_policy.cookies.title">Cookies</Translate></h2>

              <h3><Translate id="terms_and_policy.cookies.subtitle_1">Las cookies y web beacons del navegador web</Translate></h3>

              <p>
                <Translate id="terms_and_policy.cookies.text_1_1">
                  Nuestro sitio NO utiliza cookies ni web beacons. Aun así, te explicamos en qué consiste.
                  El navegador web del usuario coloca cookies en tu disco duro para propósitos como rastrear información de navegación. El usuario puede optar por configurar su navegador para que rechace las cookies o para que le avise cuando se envíen. En este supuesto, algunas partes del sitio pueden no funcionar correctamente.
                </Translate>
              </p>
              <p>
                <Translate id="terms_and_policy.cookies.text_1_2">
                  Te recordamos que este sitio web no usa cookies. Por tanto, no recopila información alguna que te identifique personalmente.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.cookies.subtitle_2">Cookies establecidas por este sitio (cookies propias)</Translate></h3>

              <p>
                <Translate id="terms_and_policy.cookies.text_2">
                  Este sitio no usa ninguna cookie propia.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.cookies.subtitle_3">Sobre las cookies de Google Analytics</Translate></h3>

                <p>
                  <Translate id="terms_and_policy.cookies.text_3">
                    Este sitio no emplea Google Analytics.
                  </Translate>
                </p>

              <h3><Translate id="terms_and_policy.cookies.subtitle_4">Cookies establecidas por terceras partes</Translate></h3>

              <p>
                <Translate id="terms_and_policy.cookies.text_4_1">
                  El contenido de este sitio podría integrar contenido de otras webs/servicios como:
                </Translate>
              </p>

              <ul>
                <li> YouTube </li>
                <li> Twitter </li>
                <li> Facebook </li>
                <li> Instagram </li>
                <li> Steam </li>
                <li> Linkedin </li>
              </ul>

              <p>
                <Translate id="terms_and_policy.cookies.text_4_2">
                  Cuando visitas una página con contenido integrado desde alguno de estos servicios puedes exponerte a cookies de estas webs. La web, los propietarios de la web y los desarrolladores de la web y el software no controlan la diseminación de esas cookies. Para más información sobre estas cookies debes ver las webs de esas terceras partes.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.cookies.subtitle_5">Cambios en esta política de privacidad</Translate></h3>

                <p>
                  <Translate id="terms_and_policy.cookies.text_5">
                    Gone Mad Studios tiene la facultad de actualizar esta política de privacidad en cualquier momento. Cuando lo hagamos, revisaremos la fecha de actualización en la parte inferior de esta página.
                    Animamos a los usuarios a comprobar con frecuencia esta página de forma que puedan mantenerse informados acerca de cómo estamos tratando la información no personal recopilada. Reconoces y aceptas que es tu responsabilidad revisar esta política de privacidad periódicamente y tomar conciencia de las modificaciones.
                  </Translate>
                </p>

              <h3><Translate id="terms_and_policy.cookies.subtitle_6">Aceptación de estos términos</Translate></h3>

              <p>
                <Translate id="terms_and_policy.cookies.text_6">
                  Al usar este sitio, expresas tu aceptación de esta política y términos de servicio. Si no estás de acuerdo con esta política, por favor no utilices nuestro sitio. El uso continuado del sitio tras la publicación de cambios a esta política será considerado como aceptación de dichas modifcaciones.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.cookies.subtitle_7">Contacto</Translate></h3>

              <p>
                <Translate id="terms_and_policy.cookies.text_7">
                  Si tienes alguna pregunta sobre esta Política de Privacidad o las prácticas de este sitio, por favor ponte en contacto con nosotros a través del correo electrónico gonemadstudios@gmail.com.
                </Translate>
              </p>

              <h2><Translate id="terms_and_policy.terms.title">Terminos</Translate></h2>

              <p>
                <Translate id="terms_and_policy.terms.text_0">
                  Estos términos de uso rigen la manera en la que el usuario puede utilizar la web de Gone Mad Studios e interaccionar con la misma. Asimismo, aclara conceptos acerca la propiedad intelectual de los contenidos publicados y establece los límites de la responsabilidad del sitio.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.terms.subtitle_1">Sobre el usuario y el uso del portal</Translate></h3>

              <p>
                <Translate id="terms_and_policy.terms.text_1">
                  El usuario accede voluntariamente a este sitio web, lo que implica que lo utilizará conforme al presente aviso legal y las Condiciones Particulares de ciertos servicios, la ley, la buena fe y/o las buenas costumbres. El portal no se ve obligado a suministrar ningún tipo de aclaración o soporte técnico sobre el uso del mismo.
                  Asimismo, el usuario asume la responsabilidad del uso del portal. Dicha responsabilidad se extenderá al registro (en caso de que fuera necesario en un futuro) para acceder a determinados servicios o contenidos.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.terms.subtitle_2">Propiedad intelectual del contenido</Translate></h3>
              <h4><Translate id="terms_and_policy.terms.subtitle_2_1">Uso comercial</Translate></h4>

              <p>
                <Translate id="terms_and_policy.terms.text_2_1">
                  El uso mediante copia o publicación (de textos, imágenes, vídeos, gráficos, logotipos, etc.) total o parcial de este sitio queda rigurosamente prohibido sin la autorización previa de Gone Mad Studios o de los propietarios de los contenidos.
                  Es indispensable la autorización previa por escrito. Para cualquier cuestión relacionada con los contenidos cuya propiedad pertenezca a Gone Mad Studios puede dirigirse a: gonemadstudios@gmail.com.
                  Se prohíbe cualquier modificación del material protegido por los derechos de autor.
                </Translate>
              </p>

              <h4><Translate id="terms_and_policy.terms.subtitle_2_2">Uso personal y académico</Translate></h4>

              <p>
                <Translate id="terms_and_policy.terms.text_2_2">
                  Los documentos pueden ser utilizados parcialmente con la condición de que se haga mención explícita de la fuente y de los derechos de autor. Para su uso en Internet, deberá incluirse necesariamente un vínculo visible y explícito, además de las menciones previstas a los efectos. Asimismo, las citas deberán incluir un vínculo o referencia exacto.
                  Aquellos contenidos cuyo propietario no sea Gone Mad Studios están sujetos a las reglas propias establecidas por el propietario de dichos contenidos. Pueden estar sujetos a una petición de autorización que deberá solicitarse directamente al propietario.
                  Atención: la información contenida en este sitio no refleja necesariamente la postura oficial de Gone Mad Studios, sino que pueden servir como testimonio, consejo y opinión de colaboradores o de internautas y son, por lo tanto, personales.
                </Translate>
              </p>

              <h4><Translate id="terms_and_policy.terms.subtitle_2_3">El logotipo y el nombre de Gone Mad Studios</Translate></h4>

              <p>
                <Translate id="terms_and_policy.terms.text_2_3">
                  Tanto el logotipo como el nombre de Gone Mad Studios están rigurosamente protegidos por los derechos de autor. El uso del nombre Gone Mad Studios o de su logotipo precisa de una autorización previa por escrito por parte de Gone Mad Studios.
                  El usuario está autorizado a ver y descargar los contenidos de la web para su uso personal con las condiciones antes mencionadas. Se prohíbe explícitamente el uso con fines lucrativos de todos los contenidos de la web, así como su incorporación en otros sitios web, en documentos electrónicos o impresos, en archivos multimedia, en aplicaciones web o en programas informáticos de cualquier tipo.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.terms.subtitle_3">Limitación de la responsabilidad</Translate></h3>

              <h4><Translate id="terms_and_policy.terms.subtitle_3_1">Sobre la información</Translate></h4>

              <p>
                <Translate id="terms_and_policy.terms.text_3_1">
                  La información contenida en este sitio web es meramente informativa y puede no ser correcta, pese a los esfuerzos realizados para llevar a cabo su exactitud y actualización. En consecuencia, no nos responsabilizamos de los errores contenidos, ni de los daños o perjuicios derivados de su utilización.
                  No nos hacemos responsables de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de disponibilidad del portal o la transmisión de virus o programas maliciosos o lesivos en los contenidos, a pesar de haber adoptado todas las medidas tecnológicas necesarias para evitarlo.
                </Translate>
              </p>

              <h4><Translate id="terms_and_policy.terms.subtitle_3_2">Sobre los enlaces</Translate></h4>

              <p>
                <Translate id="terms_and_policy.terms.text_3_2">
                  Este sitio web puede contener enlaces a otros sitios webs ajenos, enlaces que se presentan únicamente con fines informativos. La responsabilidad de los contenidos de las páginas enlazadas corresponde a los respectivos titulares de dichas páginas.
                  Nosotros no ejercemos ningún tipo de control sobre dichos sitios y contenidos. En ningún caso asumimos la responsabilidad por los contenidos de algún enlace perteneciente a un sitio web ajeno, ni garantizamos la disponibilidad técnica, calidad, fiabilidad, exactitud, amplitud, veracidad y validez de cualquier material o información contenida en ninguno de dichos hipervínculos u otros sitios de Internet.
                  Igualmente la inclusión de estas conexiones externas no implica ningún tipo de asociación, fusión o participación con las entidades conectadas.
                </Translate>
              </p>

              <h4><Translate id="terms_and_policy.terms.subtitle_3_3">Sobre las modificaciones</Translate></h4>

              <p>
                <Translate id="terms_and_policy.terms.text_3_3">
                  Nos reservamos el derecho de efectuar sin previo aviso las modificaciones que consideremos oportunas, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la web como la forma en la que estos aparezcan presentados o localizados en el portal.
                </Translate>
              </p>

              <h4><Translate id="terms_and_policy.terms.subtitle_3_4">Derecho de exclusión</Translate></h4>

              <p>
                <Translate id="terms_and_policy.terms.text_3_4">
                  Nos reservamos el derecho a denegar o retirar el acceso a portal y/o los servicios ofrecidos sin necesidad de preaviso, a instancia propia o de un tercero, a aquellos usuarios que incumplan las presentes Condiciones Generales de Uso.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.terms.subtitle_4">Generalidades</Translate></h3>

              <p>
                <Translate id="terms_and_policy.terms.text_4">
                  Perseguiremos el incumplimiento de las presentes condiciones así como cualquier utilización indebida del portal ejerciendo todas las acciones civiles y penales que puedan corresponder en derecho.
                </Translate>
              </p>

              <h3><Translate id="terms_and_policy.terms.subtitle_5">Modificación de las presentes condiciones y duración</Translate></h3>

              <p>
                <Translate id="terms_and_policy.terms.text_5">
                  Podremos modificar en cualquier momento las condiciones aquí determinadas, siendo debidamente publicadas como aquí aparecen. La vigencia de las citadas condiciones irá en función de su exposición y estarán vigentes hasta que sean modificadas por otras debidamente publicadas.
                  El contenido de este documento fue actualizado por última vez a 07 de Marzo de 2019.
                </Translate>
              </p>

            </Col>
          </Row>
        </Container>
      </section>
      );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SetHeaderNavbar: (haveHeader) => {dispatch(ChangeNavbar(haveHeader))}
  }
}

function mapStateToProps(state) {
  return { }
}

export default connect (
  mapStateToProps,
  mapDispatchToProps
)(TermsAndPolicy);
